export default "__VITE_ASSET__Dhe7blCk__"